import { Fragment } from 'react';
import {
  bool,
  element,
  func,
  number,
  object,
  shape,
  string,
} from 'prop-types';
import {
  Box,
  Slider,
  Typography,
} from '@material-ui/core';

function Fieldset({ label, children }) {
  return (
    <fieldset style={{
      borderRadius: 5,
    }}>
      <legend style={{
        marginLeft: 8,
      }}>
        <Typography color="textSecondary" variant="caption">
          <Box style={{
            marginLeft: 5,
            marginRight: 5,
          }}>
            {label}
          </Box>
        </Typography>
      </legend>
      <Box style={{
        marginLeft: 15,
        marginRight: 15,
      }}>
        {children}
      </Box>
    </fieldset>);
}

function SliderControl(props) {
  const {
    events = {},
    label,
    name,
    value,
    settings = {},
    onChange,
  } = props;
  const {
    max = 100,
    marks = true,
    min = 0,
    step = max / 10,
  } = settings;

  const Container = label
    ? Fieldset
    : Fragment;

  const handleSliderChange = (event, value) => {
    const target = {
      name,
      value,
    };

    onChange({
      target,
    });

    if (events.onChange) {
      events.onChange(target);
    }
  };

  return (
    <Container label={label}>
      <Slider
        aria-labelledby="discrete-slider"
        defaultValue={value}
        max={max}
        marks={marks}
        min={min}
        step={step}
        valueLabelDisplay="auto"
        onChange={handleSliderChange}
      />
    </Container>
  );
}

Fieldset.propTypes = {
  label: string,
  children: element,
};

SliderControl.defaultProps = {
  value: 0,
  onChange: () => { },
  onBlur: () => { },
};

SliderControl.propTypes = {
  events: object,
  label: string,
  name: string,
  settings: shape({
    max: number,
    marks: bool,
    min: number,
    step: number,
  }),
  value: number,
  onChange: func,
};

export default SliderControl;
